import request from '@/utils/request'


// 查询订单箱规列表
export function listOrderBox(query) {
  return request({
    url: '/user/order-box/list',
    method: 'get',
    params: query
  })
}

// 查询订单箱规分页
export function pageOrderBox(query) {
  return request({
    url: '/user/order-box/page',
    method: 'get',
    params: query
  })
}

// 查询订单箱规详细
export function getOrderBox(data) {
  return request({
    url: '/user/order-box/detail',
    method: 'get',
    params: data
  })
}

// 新增订单箱规
export function addOrderBox(data) {
  return request({
    url: '/user/order-box/add',
    method: 'post',
    data: data
  })
}

// 修改订单箱规
export function updateOrderBox(data) {
  return request({
    url: '/user/order-box/edit',
    method: 'post',
    data: data
  })
}

// 删除订单箱规
export function delOrderBox(data) {
  return request({
    url: '/user/order-box/delete',
    method: 'post',
    data: data
  })
}
